module.exports = __webpack_public_path__ + "img/error.3ccca0a1.png";